/**
 * Generated from platform/mapping-service/data/company_taxonomy.json.
 * Run platform/export/taxonomyconstantsexport.py to update.
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons/faArrowTrendUp';
import { faBellConcierge } from '@fortawesome/free-solid-svg-icons/faBellConcierge';
import { faBinoculars } from '@fortawesome/free-solid-svg-icons/faBinoculars';
import { faBookAtlas } from '@fortawesome/free-solid-svg-icons/faBookAtlas';
import { faBookMedical } from '@fortawesome/free-solid-svg-icons/faBookMedical';
import { faBookOpenReader } from '@fortawesome/free-solid-svg-icons/faBookOpenReader';
import { faBrain } from '@fortawesome/free-solid-svg-icons/faBrain';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faBug } from '@fortawesome/free-solid-svg-icons/faBug';
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faBuildingColumns } from '@fortawesome/free-solid-svg-icons/faBuildingColumns';
import { faBuildingUser } from '@fortawesome/free-solid-svg-icons/faBuildingUser';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator';
import { faCarSide } from '@fortawesome/free-solid-svg-icons/faCarSide';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { faCashRegister } from '@fortawesome/free-solid-svg-icons/faCashRegister';
import { faChartArea } from '@fortawesome/free-solid-svg-icons/faChartArea';
import { faChartColumn } from '@fortawesome/free-solid-svg-icons/faChartColumn';
import { faChartGantt } from '@fortawesome/free-solid-svg-icons/faChartGantt';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faChartSimple } from '@fortawesome/free-solid-svg-icons/faChartSimple';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons/faClipboardCheck';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons/faCloudArrowUp';
import { faCloudBolt } from '@fortawesome/free-solid-svg-icons/faCloudBolt';
import { faCodeCommit } from '@fortawesome/free-solid-svg-icons/faCodeCommit';
import { faCodeCompare } from '@fortawesome/free-solid-svg-icons/faCodeCompare';
import { faCoins } from '@fortawesome/free-solid-svg-icons/faCoins';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faCompassDrafting } from '@fortawesome/free-solid-svg-icons/faCompassDrafting';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faEarthAmericas } from '@fortawesome/free-solid-svg-icons/faEarthAmericas';
import { faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons/faEnvelopeCircleCheck';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFaceSmile } from '@fortawesome/free-solid-svg-icons/faFaceSmile';
import { faFileCircleCheck } from '@fortawesome/free-solid-svg-icons/faFileCircleCheck';
import { faFileCode } from '@fortawesome/free-solid-svg-icons/faFileCode';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons/faFileInvoiceDollar';
import { faFileMedical } from '@fortawesome/free-solid-svg-icons/faFileMedical';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons/faFingerprint';
import { faFlask } from '@fortawesome/free-solid-svg-icons/faFlask';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faGavel } from '@fortawesome/free-solid-svg-icons/faGavel';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons/faHandHoldingHeart';
import { faHandshake } from '@fortawesome/free-solid-svg-icons/faHandshake';
import { faHeadset } from '@fortawesome/free-solid-svg-icons/faHeadset';
import { faHeartPulse } from '@fortawesome/free-solid-svg-icons/faHeartPulse';
import { faHelmetSafety } from '@fortawesome/free-solid-svg-icons/faHelmetSafety';
import { faHospitalUser } from '@fortawesome/free-solid-svg-icons/faHospitalUser';
import { faHouseChimneyUser } from '@fortawesome/free-solid-svg-icons/faHouseChimneyUser';
import { faIdBadge } from '@fortawesome/free-solid-svg-icons/faIdBadge';
import { faIndustry } from '@fortawesome/free-solid-svg-icons/faIndustry';
import { faLandmarkFlag } from '@fortawesome/free-solid-svg-icons/faLandmarkFlag';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons/faLaptopCode';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faMagnifyingGlassChart } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassChart';
import { faMessage } from '@fortawesome/free-solid-svg-icons/faMessage';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons/faMicrochip';
import { faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons/faMoneyBillTransfer';
import { faMoneyBillTrendUp } from '@fortawesome/free-solid-svg-icons/faMoneyBillTrendUp';
import { faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons/faMoneyCheckDollar';
import { faNetworkWired } from '@fortawesome/free-solid-svg-icons/faNetworkWired';
import { faNotesMedical } from '@fortawesome/free-solid-svg-icons/faNotesMedical';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons/faPhoneVolume';
import { faPlugCircleBolt } from '@fortawesome/free-solid-svg-icons/faPlugCircleBolt';
import { faPlugCircleCheck } from '@fortawesome/free-solid-svg-icons/faPlugCircleCheck';
import { faReceipt } from '@fortawesome/free-solid-svg-icons/faReceipt';
import { faRobot } from '@fortawesome/free-solid-svg-icons/faRobot';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons/faScaleBalanced';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons/faScrewdriverWrench';
import { faServer } from '@fortawesome/free-solid-svg-icons/faServer';
import { faShapes } from '@fortawesome/free-solid-svg-icons/faShapes';
import { faShareNodes } from '@fortawesome/free-solid-svg-icons/faShareNodes';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons/faShieldHalved';
import { faShieldHeart } from '@fortawesome/free-solid-svg-icons/faShieldHeart';
import { faShieldVirus } from '@fortawesome/free-solid-svg-icons/faShieldVirus';
import { faSitemap } from '@fortawesome/free-solid-svg-icons/faSitemap';
import { faStarHalfStroke } from '@fortawesome/free-solid-svg-icons/faStarHalfStroke';
import { faStore } from '@fortawesome/free-solid-svg-icons/faStore';
import { faToolbox } from '@fortawesome/free-solid-svg-icons/faToolbox';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faTruckFast } from '@fortawesome/free-solid-svg-icons/faTruckFast';
import { faUmbrella } from '@fortawesome/free-solid-svg-icons/faUmbrella';
import { faUnlockKeyhole } from '@fortawesome/free-solid-svg-icons/faUnlockKeyhole';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons/faUserSecret';
import { faVault } from '@fortawesome/free-solid-svg-icons/faVault';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faWallet } from '@fortawesome/free-solid-svg-icons/faWallet';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons/faWandMagicSparkles';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons/faWarehouse';
import { faWindowMaximize } from '@fortawesome/free-solid-svg-icons/faWindowMaximize';

export const MARKET_ICON_DEFINITIONS = {
  "Operational Databases": faDatabase,
  "Data Warehouses & Lakehouses": faWarehouse,
  "Business Intelligence & Analytics": faChartColumn,
  "Product Analytics": faChartSimple,
  "Data Governance & Catalog": faBookAtlas,
  "Search & Retrieval": faMagnifyingGlassChart,
  "DevSecOps & Delivery": faCodeCommit,
  "Cloud & Platform Ops": faCloudBolt,
  "Developer Platforms": faLaptopCode,
  "Incident Response": faTriangleExclamation,
  "Observability & APM": faChartLine,
  "AI Coding & Agents": faFileCode,
  "iPaaS & API Integration": faPlugCircleCheck,
  "API Management & Middleware": faServer,
  "Data Integration & Orchestration": faPlugCircleBolt,
  "Identity & Access Management": faFingerprint,
  "Endpoint Security": faShieldHalved,
  "Endpoint & Device Management": faDesktop,
  "MSP IT Management & RMM": faScrewdriverWrench,
  "Cloud Security & CNAPP": faShieldVirus,
  "Network Security & SASE": faNetworkWired,
  "Data Security & DSPM": faLock,
  "Backup & Recovery": faVault,
  "Exposure Management": faBug,
  "Security Operations & SIEM": faEye,
  "GRC, Privacy & Compliance": faScaleBalanced,
  "Email & Human Risk": faEnvelopeCircleCheck,
  "Hosting & Cloud Platforms": faCloudArrowUp,
  "CDN & Edge Delivery": faGlobe,
  "Networking": faSitemap,
  "Foundation Models": faBrain,
  "AI Data & Developer Platforms": faClipboardCheck,
  "Model Serving & Inference": faRobot,
  "Synthetic Media": faWandMagicSparkles,
  "ITSM & ESM": faHeadset,
  "Project & Work Management": faChartGantt,
  "Low-Code & Automation": faCodeCompare,
  "Search & Knowledge": faMagnifyingGlass,
  "CRM & Sales Platforms": faHandshake,
  "Marketing Automation": faBullhorn,
  "Support & Contact Center": faComments,
  "Customer Success & CX": faFaceSmile,
  "Communications APIs": faPhoneVolume,
  "Social & Reputation Management": faShareNodes,
  "Revenue Intelligence": faMoneyBillTrendUp,
  "Collaboration & Messaging": faMessage,
  "Content Management & File Sharing": faFolderOpen,
  "Creative & Design": faPalette,
  "Events & Video": faVideo,
  "Website & Digital Presence": faWindowMaximize,
  "HCM & Payroll": faIdBadge,
  "Learning & Talent": faGraduationCap,
  "Finance, ERP & EPM": faCoins,
  "Accounting Automation": faCalculator,
  "Procurement & Spend Management": faCartShopping,
  "Tax & Compliance": faReceipt,
  "Contract Lifecycle Management": faFileSignature,
  "Supply Chain & Logistics": faTruckFast,
  "Life Sciences & Pharma": faFlask,
  "Provider EHR & Clinical Systems": faHospitalUser,
  "Revenue Cycle & Healthcare Operations": faFileMedical,
  "AI Clinical Documentation": faNotesMedical,
  "Medical Knowledge & Decision Support": faBookMedical,
  "Banking & Lending": faBuildingColumns,
  "Insurance": faUmbrella,
  "Investment & Asset Management": faChartPie,
  "Capital Markets Workflow": faArrowTrendUp,
  "Financial Services Data & Analytics": faChartSimple,
  "Construction Management": faHelmetSafety,
  "Property Management": faBuilding,
  "Field Service Management": faToolbox,
  "Home Services & Trades": faHouseChimneyUser,
  "CAD, PLM & Design Engineering": faCompassDrafting,
  "Simulation & EDA": faMicrochip,
  "Industrial Operations & IoT": faIndustry,
  "Automotive & Autonomy": faCarSide,
  "K-12 & Higher Education": faGraduationCap,
  "Government & Civic": faLandmarkFlag,
  "Public Safety & Justice": faShieldHeart,
  "Legal Practice Management": faGavel,
  "Legal AI & Document Review": faFileCircleCheck,
  "Professional Services Operations": faBriefcase,
  "Fitness, Wellness & Local Services": faHeartPulse,
  "Nonprofit & Association Management": faHandHoldingHeart,
  "Hospitality & Leisure Operations": faBellConcierge,
  "Global Technology Platform": faEarthAmericas,
  "Diversified Enterprise Software": faLayerGroup,
  "Vertical Software Holding Company": faBuildingUser,
  "Multi-Segment Software Platform": faShapes,
  "Merchant Processing": faCashRegister,
  "Payment Networks": faCreditCard,
  "Wallets & Checkout": faWallet,
  "Cross-Border Payments": faMoneyBillTransfer,
  "Commerce & POS": faStore,
  "AP/AR Automation": faFileInvoiceDollar,
  "Spend Management": faMoneyCheckDollar,
  "Banking Connectivity": faUnlockKeyhole,
  "Core Banking": faVault,
  "Fraud & Risk Infrastructure": faUserSecret,
  "Market Data & Indices": faChartArea,
  "Credit, Ratings & Risk": faStarHalfStroke,
  "Market Intelligence": faBinoculars,
  "Research & Advisory": faBookOpenReader,
};

const createMarketIcon = (icon) => {
  const MarketIcon = () => <FontAwesomeIcon icon={icon} fixedWidth />;
  MarketIcon.displayName = `MarketIcon(${icon.iconName})`;
  return MarketIcon;
};

export const MARKET_ICON_COMPONENTS = Object.fromEntries(
  Object.entries(MARKET_ICON_DEFINITIONS).map(([market, icon]) => [market, createMarketIcon(icon)])
);
